import React from 'react';
import { clsx } from 'clsx';

import { InputContainer, Props as BaseProps } from '../input-container';

type HtmlInputProps = Omit<JSX.IntrinsicElements['input'], 'ref'>;
type Props = HtmlInputProps &
  BaseProps & {
    addon?: string;
    hasDecimalPart?: boolean;
    register: (any: any) => any;
  };

const Input: React.FC<Props> = ({ id, label, addon, hasDecimalPart, error, register, valueAsNumber, ...props }) => (
  <InputContainer id={id} label={label} error={error}>
    {addon && (
      <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
        {addon}
      </span>
    )}

    <input
      {...props}
      id={id}
      name={props.name || id}
      className={clsx('form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5', {
        'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:ring-red': error,
      })}
      ref={register({
        required: props.required,
        valueAsNumber: Boolean(valueAsNumber),
        ...(hasDecimalPart && { validate: (value: string) => !value.includes(',') || 'Usa punto para decimales.' }),
      })}
      aria-required={props.required}
    />
  </InputContainer>
);

Input.defaultProps = {
  type: 'text',
};

export default Input;
